import '.a{display:flex;}.ssr-plugin'
import '.q{flex-direction:row;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bg{height:100vh;}.ssr-plugin'
import '.al{flex-grow:1;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.bl{overflow-y:auto;}.ssr-plugin'
import '.fc{margin-top:2rem;}.ssr-plugin'
import '.de{min-height:0px;}.ssr-plugin'
import '.fn{max-width:60rem;}.ssr-plugin'
import '.fo{margin-left:auto;}.ssr-plugin'
import '.fp{margin-right:auto;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'
import Column from '@app/components/layout/Column'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Column alignItems="stretch">
        <div className="a q t bg"
          style={{
            padding: isMobile ? '0rem' : '1.5rem',
            gap: isMobile ? 0 : '5rem',}}
        >
          <InitiativeSideBar />

          <div className="al aa a b"
          >
            <DashboardNavBar
              initiativeDashboard={true}
              style={{ backgroundColor: 'var(--palette-white)' }}
            />
            <div className="l al bl"
            >
              <div className="l a b fc de fn fo fp"
                style={{
                  gap: gap,
                  paddingInline: isMobile ? '1rem' : 0,}}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </Column>
    </ClientOnly>
  )
}
